/**
 * @generated SignedSource<<38e8965651309ef597c997bc857f1ec9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPostItem_item$data = {
  readonly date: string;
  readonly excerpt: string;
  readonly imageUrl: string | null;
  readonly slug: string;
  readonly title: string;
  readonly " $fragmentType": "BlogPostItem_item";
};
export type BlogPostItem_item$key = {
  readonly " $data"?: BlogPostItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPostItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};

(node as any).hash = "6bcab581071c2ca79d30f87057149968";

export default node;
